import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MenuItem, Select, FormControl, ListItemText } from '@mui/material';
import { setSortOption, selectSortOption } from '../../../../../store/slices/swarmsInAction';

const SORT_OPTIONS = [
  { value: 'bteId', label: 'BteId' },
  { value: 'highestReward', label: 'Highest Reward' },
  { value: 'dateTime', label: 'Date/Time' },
  { value: 'performerName', label: 'Performer Name' }
];

const STORAGE_KEY = 'selectedSortOption';

const SwarmsSortDropDown = () => {
  const dispatch = useDispatch();
  const selectedSortOption = useSelector(selectSortOption);
  const [sortOption, setSortOptionState] = useState(selectedSortOption || 'bteId');

  useEffect(() => {
    const savedSortOption = localStorage.getItem(STORAGE_KEY);
    if (savedSortOption) {
      setSortOptionState(savedSortOption);
      dispatch(setSortOption(savedSortOption));
    }
  }, [dispatch]);

  const handleChange = (event) => {
    const newSortOption = event.target.value;
    setSortOptionState(newSortOption);
    dispatch(setSortOption(newSortOption));
    localStorage.setItem(STORAGE_KEY, newSortOption);
  };

  return (
    <FormControl sx={{ m: 1, width: 150 }}>
      <Select
        labelId="swarms-sort-dropdown-label"
        id="swarms-sort-dropdown"
        value={sortOption}
        onChange={handleChange}
        renderValue={(selected) => {
          const selectedOption = SORT_OPTIONS.find(option => option.value === selected);
          return selectedOption ? selectedOption.label : '';
        }}
        sx={{height: "2em", backgroundColor: "white" }}
      >
        {SORT_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SwarmsSortDropDown;